/* Espelha Form.vue (#report-box) - referência: assets/img/references/demonstrative-reference.png */

export default `
.report-box {
  position: relative;
  min-height: 1050px;
  max-width: 800px;
  padding: 5px 20px 5px 5px;
  margin: 20px;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 24px;
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
  color: #343a40;
}

.report-box table {
  width: 100%;
}

#report-box .slim-pagetitle {
  margin-top: 15px;
  margin-bottom: 10px;
  color: #343a40;
  padding-left: 10px;
  border-left: 4px solid #4662d4;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #343a40;
  padding: 5px;
  margin-left: 10px;
  margin-right: 10px;
}

#report-box hr {
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 5px;
}

#report-box .header {
  font-size: 12px;
}

#report-box .header-left {
  text-align: center;
  border-left: 10px solid #4662d4 !important;
  vertical-align: top;
}

#report-box .header-middle {
  padding-left: 20px;
  text-align: left !important;
  line-height: 20px;
  vertical-align: top;
}

#report-box .header-right {
  vertical-align: top;
  line-height: 10px;
}

#report-box .header-right small {
  font-size: 10px;
}

#report-box .info-row,
#report-box .info-row-simple {
  font-size: 14px;
}

#report-box .information table.info-table {
  margin: 10px;
}

#report-box .report-box table:not(.info-table) td,
#report-box .report-box table:not(.info-table) th {
  padding: 0 !important;
  background-color: transparent !important;
  min-width: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
}

#report-box .information table.info-table tr.info-row td {
  padding: 2px 0 2px 0 !important;
  background-color: transparent !important;
  min-width: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 1px dashed #dee2e6 !important;
}

#report-box .info-row td.label {
  text-align: left;
  font-weight: bold;
}

#report-box .info-row td.value {
  text-align: left;
}

#report-box .info-row-simple td.check {
  border: 1px solid;
  width: 18px;
}

#report-box .footer {
  position: absolute;
  left: 0;
  bottom: 10px;
  width: 100%;
  text-align: center;
  line-height: 8px;
}

#report-box .footer small {
  font-size: 9px;
}

#report-box,
#report-box * {
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif !important;
}

#report-box h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  line-height: 18px;
  color: #343a40;
}

#report-box strong {
  font-weight: bold;
}

#report-box small {
  font-size: 9px;
}
`;
